angular.module('zc.projects')

.directive 'zcCampaignSegmentRow', (CampaignSegment, Meta, $state, lib) ->
  restrict: 'E'
  templateUrl: "/templates/projects.segments/campaign_segment_row.html"
  replace: true
  scope:
    campaign: "="
  link: (scope, element, attrs) ->



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.segments/campaign_segment_row.directive.coffee